module.exports = __webpack_public_path__ + "static/3.2_750x380_Patient_Doctor_Desktop_1X-a8fadca8a778d0b15e13ee82df95f07f.png";